import { ref, watch } from 'vue'
import { useOrganizationsStore } from '@/stores/organizations.store'

export default function useList(organizationId) {
  const listTable = ref([])

  // Table Handlers
  const tableColumns = [
    { text: 'Name', value: 'name' },
    { text: 'CreatedAt', value: 'created_at' },
    { text: 'UpdatedAt', value: 'updated_at' },
    {
      text: 'Action',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]

  const searchQuery = ref('')
  const options = ref({
    sortBy: ['created_at'],
    sortDesc: [false],
  })
  const totalListTable = ref(0)
  const loading = ref(false)
  const selectedTableData = ref([])
  const isAddDialogVisible = ref(false)
  const isDeleteDialogVisible = ref(false)
  const organizationsStore = useOrganizationsStore()

  const fetchDatas = () => {
    organizationsStore
      .getProjectsOrganization({ organizationId, search: searchQuery.value, options: options.value })
      .then(data => {
        listTable.value = data.data
        totalListTable.value = data.count
        loading.value = false
      })
      .catch(() => {
        listTable.value = []
        totalListTable.value = 0
        loading.value = false
      })
  }

  watch([searchQuery, options, isAddDialogVisible, isDeleteDialogVisible], () => {
    loading.value = true
    selectedTableData.value = []
    fetchDatas()
  })

  return {
    tableColumns,
    searchQuery,
    options,
    listTable,
    totalListTable,
    loading,
    selectedTableData,
    fetchDatas,
    isAddDialogVisible,
    isDeleteDialogVisible,
  }
}
